












































































































































































































  import { Component, Prop, Vue, Watch } from "vue-property-decorator";
  import YcHeader from "@/components/common/yc-header.vue";
  import YcAside from "@/components/common/yc-aside.vue";
  import YcColorPicker from "@/components/color-picker/index.js";
  import Exhibition from '../components/exhibition.vue'
import InfoPopover from '../components/InfoPopover.vue'
  import {TFormSaveDetailRequest} from "@/model/FormWheel";
import { getQueryVariable,getCommonConfig, Country, getCountryList } from "@/services/api";
import { getCompanyInfo } from "@/model/CompanyInfo";
import { isEnableMultipleLanguages, isEnablePopSetting } from "@/utils/experiment";
  
  enum permissionType {EDIT = 'edit', CHECK = 'check'}
  
  @Component({
    components: {
      "yc-aside": YcAside,
      "yc-header": YcHeader,
      "yc-color-picker": YcColorPicker,
      'yc-exhibition': Exhibition,
      'info-popover': InfoPopover,
    },
  })
  export default class rulesSetting extends Vue {
    @Prop(Object)
    formData!: TFormSaveDetailRequest;

    @Prop(Object)
    targetingData!:any

    @Prop(Object)
    rulesData!:any

    @Prop(String)
    activeTag?:string

    targeting = this.targetingData
    rules = this.rulesData
    blankCloseArray = [30, 621, 907, 1333, 1334, 1379, 1738]
    companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id;

    countryList: Country[] = [{
      countryAbbreviation: 'CN',
      country: 'China',
      countryName: '中国'
    }];

    get enableMultipleLanguages() {
      return isEnableMultipleLanguages();
    }

    get isAbtest() {
      return getQueryVariable('abtest') === 'true';
    }

    get isEditAbTest() {
      return getQueryVariable('abtest') === 'true' && getQueryVariable('edit') === 'true';
    }

    get enablePopSetting() {
      return isEnablePopSetting();
    }


    changeUrls({url , urlParts}:any){
      this.targeting.urls = url
      this.targeting.urlParts = urlParts
      this.changeTargetingData()
      window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
    }
    changeExcludeUrls({url , urlParts}:any){
      this.targeting.excludeUrls = url
      this.targeting.excludeUrlParts = urlParts
      this.changeTargetingData()
      window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
    }

    changeTargetingData(){
      this.$emit('changeTargetingData',this.targeting)
      if(this.rules.clickBackgroundCloseOption){
        window?.gtagClick('form_edit_toggleClickClose','弹窗_编辑订阅工具_设置空白处点击关闭')
      }
    }


    messagetips(){
      this.$alert(`<p>支持输入域名、完整URL链接及URL后缀“/” </p>
      <p>支持使用“*”作为通配符 </p>
      <p style="font-weight: bold;">1、需要准确在某些页面打开弹窗时使用【等于】</p>
      <p>希望在首页展示弹窗，使用页面URL 等于【yourdomain.com/】；</p>
      <p>希望在collection页展示弹窗，使用页面URL等于【yourdomain.com/en-ja/collections/*】 collection页根据网站命名对应修改；</p>
      <p>希望在detail页展示弹窗，使用页面URL等于【yourdomain.com/en-ja/products/*】detail页根据网站命名对应修改；</p>
      <br/>
      <p style="font-weight: bold;">2、需要通过某个链接内带关键词就触发弹窗时使用【包含】</p>
      <p>希望在collection页展示弹窗，使用页面URL包含【collections/*】 collection页根据网站命名对应修改；</p>
      <p>希望在detail页展示弹窗，使用页面URL包含【products/*】detail页根据网站命名对应修改；</p>`,
      '提示', {
        confirmButtonText: '我知道了',
        dangerouslyUseHTMLString: true
      });

    }
    //校验
    targetingValid(){
      //在特定页面展示为空
      if (this.$refs.inPages && !this.$refs.inPages.valid() ) {
        return false
      }
      //不在特定页面展示
      if (this.$refs.noInPages && !this.$refs.noInPages.valid() ) {
        return false
      }

      //两个筛选条件不能存在相同的URL
      let includeUrls = this.targeting?.urls?.concat(this.targeting?.urlParts)
      let excludeUrls = this.targeting?.excludeUrls?.concat(this.targeting?.excludeUrlParts)
      let count = 0
      includeUrls?.forEach((includeItem) => {
        excludeUrls?.forEach((excludeItem) => {
          if(includeItem.url == excludeItem.url){
            count++
          }
        });
      });
      if(count != 0){
        this.$message.warning('URL不能相同')
        return false
      }

      if (
        this.formData.settings.position?.iconCustom &&
        (this.formData.settings.position?.iconCustomBottom === undefined || typeof +this.formData.settings.position?.iconCustomBottom !== 'number' || isNaN(+this.formData.settings.position?.iconCustomBottom))
      ) {
        this.$message.warning('自定义边距值不可为空')
        return false
      }

      return true
    }

    translateValid() {
      if (this.rules.includeArea && this.rules.includeAreaList.length <= 0) {
        this.$message.warning('向特定位置的用户展示为空，请选择');
        return false
      }

      if (this.rules.excludeArea && this.rules.excludeAreaList.length <= 0) {
        this.$message.warning('不向特定位置的用户展示为空，请选择');
        return false
      }

      return true;
    }

    valid() {
      if (this.enableMultipleLanguages) {
        return this.targetingValid() && this.translateValid()
      } else {
        return this.targetingValid()
      }
    }

    changeIncludeArea(val: any){
      if (!val) {
        this.rules.includeAreaList = [];
      }
      window?.gtagClick('form_edit_country_display', '弹窗_编辑订阅工具_国家显示设置');
    }

    changeExcludeArea(val: any){
      if (!val) {
        this.rules.excludeAreaList = [];
      }
      window?.gtagClick('form_edit_country_display', '弹窗_编辑订阅工具_国家显示设置');
    }

    /**
     * 保存草稿
     */
    saveDraft() {
      if (this.isAbtest) {
        if (!this.isEditAbTest) {
          return;
        }
      }
      if (this.valid()) {
        this.$emit('saveDraft')
      }
    }

    /**
     * 发布
     */
    save() {
      if (this.valid()) {
        this.$emit('save')
      }
    }

    /**
     * 上一步
     */
    backStep() {
      this.$emit('backStep')
    }

    /**
     * 取消
     */
    cancel() {
      if (this.valid()) {
        this.$emit('cancel')
      }
    }

    @Watch('targetingData')
    changetargetingData(val:any){
      this.targeting = val
      this.setInitData();
    }
  

    showTargetUrl = false;
    showTarget() {
      this.showTargetUrl = !this.showTargetUrl;
    }

    selectList = {
      "1":false,
      "2":false,
      "3":false,
      "4":false,
      "5":false,
    }

    showPageCheckout = false;

    async getMask (){
      try {
        const result = await getCommonConfig('formClickBlankCloseStart');
        this.blankCloseArray = JSON.parse(result?.data?.data)
      } catch (e) {
        console.error('getCommonConfig formClickBlankCloseStart error', e);
      }
    }

    created() {
      this.setInitData();
      this.getMask()
      if (this.enableMultipleLanguages) {
        this.getCountryList();
      }
    }

    nextStep() {
      if (this.valid()) {
        this.$emit('nextStep')
      }
    }

    async getCountryList() {
      try {
        const result = await getCountryList({});
        this.countryList = result.data.data;
      } catch (e: any) {
        if (e?.handled) {
          return;
        }
        this.$message.warning('获取国家列表失败!');
      }
    }

    setInitData () {
      if (this.targeting?.urls?.length > 0 ||
        this.targeting?.urlParts?.length > 0 ||
        this.targeting?.excludeUrls?.length > 0 ||
        this.targeting?.excludeUrlParts?.length > 0) {
        this.showTargetUrl = true;
      }
      if (this.targeting.pages?.includes('1')) {
        this.selectList['1'] = true;
      }
      if (this.targeting.pages?.includes('2')) {
        this.selectList['2'] = true;
      }
      if (this.targeting.pages?.includes('3')) {
        this.selectList['3'] = true;
      }
      if (this.targeting.excludePages?.includes('4')) {
        this.selectList['4'] = true;
      }
      if (this.targeting.excludePages?.includes('5')) {
        this.selectList['5'] = true;
      }
      this.showPageCheckout = false;
      this.$nextTick(() => {
        this.showPageCheckout = true;
        this.$forceUpdate();
      });
    }

    targetIsChecked(pageId:any) {
      return this.targeting.pages?.includes(pageId);
    }
    targetChecked(checked:boolean, pageId:any) {
      this.targeting.pages = this.targeting.pages?.filter((oldId:any) => pageId != oldId) || [];
      if (checked) {
        this.targeting.pages.push(pageId);
      }
      this.changeTargetingData()
      window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
    }
    targetExcludeIsChecked(pageId:any) {
      return this.targeting.excludePages?.includes(pageId);
    }
    targetExcludeChecked(checked:boolean, pageId:any) {
      this.targeting.excludePages = this.targeting.excludePages?.filter((oldId:any) => pageId != oldId) || [];
      if (checked) {
        this.targeting.excludePages.push(pageId);
      }
      this.changeTargetingData()
      window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
    }
  
  }
  